import { useTranslation } from 'react-i18next';

// TODO: Move to lang
export default function useConvertRegionToShort() {
  const { t } = useTranslation();

  const convertRegionToShort = (region) => {
    switch (region) {
      case 'GLOBAL':
        return t('constants.global');
      case 'NORDIC':
      case 'NORDICWEB':
        return t('constants.nordic');
      case 'SWEDEN':
      case 'SWEDENWEB':
        return 'SE';
      case 'DENMARK':
      case 'DENMARKWEB':
        return 'DK';
      case 'NORWAY':
      case 'NORWAYWEB':
        return 'NO';
      case 'FINLAND':
      case 'FINLANDWEB':
        return 'FI';
      case 'GERMANY':
      case 'GERMANYWEB':
        return 'DE';
      case 'NETHERLANDS':
      case 'NETHERLANDSWEB':
        return 'NL';
      case 'PORTUGAL':
        return 'PT';
      case 'UK':
        return 'GB';

      default:
        return 'N/A';
    }
  };

  return convertRegionToShort;
}
